import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import { useLocation } from 'react-router-dom'

import ImgBox from '../../components/Gamification/ImgBox'
import CreatNft from '../../components/Gamification/CreatNft'
// import {Info} from '../../components/Gamification/InfoBox'
import { RowColumn } from '../../components/Row'

import { NFTTYPE } from '../../constants/bakery/nft'

const SoccerMain = styled.div`
  width: 890px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 100%;
  `};
`
const Main = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
const activeClassName = 'ACTIVENAV'

export const Info = styled.div`
  color: ${({ theme }) => theme.bsText7};
  width: 432px;
  height: 202px;
  overflow-y: scroll;
  padding: 16px 30px;
  border-radius: 20px;
  background: ${({ theme }) => theme.bsBg2};
  &.${activeClassName}{
    height: 290px;
  };
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-bottom: 20px;
  `};
`


export default function Soccer () {
  const location = useLocation()
  return (
    <SoccerMain>
      <Main>
        <ImgBox imgLink={'/images/nft/poker.gif'}/>
        <RowColumn>
          <CreatNft type={NFTTYPE.POKER} />
          <Info className={location.pathname.indexOf('gamification/poker') > -1 ? activeClassName : ''}>
            <Text fontSize={18} fontFamily={'Baloo Da'} fontWeight={700}>What are Poker BlindBox NFTs?</Text>
            <Text fontSize={14} marginTop={20}>1. One Blind Box NFT can be opened to get a random PET Poker Card NFT.  </Text>
            <Text fontSize={14} marginTop={20}>2. Poker Card NFT can be used to farm $BAKE and trade on the NFT Marketplace. </Text>
            <Text fontSize={14} marginTop={20}>3. Each PET Poker Card can be converted to a real-world limited edition of the Standard 52-card deck, which can be delivered to you! This will happen if you choose to burn the Poker Card.</Text>
          </Info>
        </RowColumn>
      </Main>
    </SoccerMain>
  )
}